import { LitElement, css, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import TeknikAuthService from '../services/teknik-auth-service.js';
import { teknikTokens, teknikButtons } from '../styles/teknik-tokens.js';
import { tkPrimitives } from '../styles/tk-primitives.js';
import { tkAuthCard } from '../styles/tk-auth.js';

@customElement('app-register')
export class AppRegister extends LitElement {
  @state() email = '';
  @state() username = '';
  @state() password = '';
  @state() confirmPassword = '';
  @state() referralCode = '';
  @state() referrerName = '';
  @state() error = '';
  @state() loading = false;

  async connectedCallback() {
    super.connectedCallback();
    const ref = new URLSearchParams(window.location.search).get('ref');
    if (ref) {
      this.referralCode = ref;
      try {
        const res = await fetch(`/api/teknik/referral/${ref}`);
        const data = await res.json();
        if (data.valid) this.referrerName = data.referrerUsername;
      } catch {}
    }
  }

  async handleRegister(e: Event) {
    e.preventDefault();
    this.error = '';

    if (this.password !== this.confirmPassword) {
      this.error = "Those passwords don't match.";
      return;
    }
    if (this.password.length < 8) {
      this.error = 'Use at least 8 characters.';
      return;
    }

    this.loading = true;
    const result = await TeknikAuthService.register(this.email, this.username, this.password, this.referralCode);
    this.loading = false;

    if (result.success) {
      window.location.href = '/';
    } else {
      this.error = result.error || "Couldn't create that account.";
    }
  }

  static styles = [
    teknikTokens,
    teknikButtons,
    tkPrimitives,
    tkAuthCard,
    css`
      .label-note { font-weight: 400; font-size: .78rem; color: var(--tk-dim); }
    `,
  ];

  render() {
    return html`
      <main>
        <div class="card">
          <div class="eyebrow">Create account</div>
          <h1 class="title">Join Teknik</h1>
          <p class="sub">Free to create.</p>

          ${this.referrerName
            ? html`<div class="tk-flash" style="margin-bottom:1rem">
                Invited by <strong style="color:var(--tk-accent)">${this.referrerName}</strong>
              </div>`
            : ''}

          ${this.error ? html`<div class="tk-flash err" style="margin-bottom:1rem">${this.error}</div>` : ''}

          <form @submit=${this.handleRegister}>
            <div class="field">
              <label class="tk-label" for="email">Email</label>
              <input
                id="email" class="tk-input" type="email" placeholder="you@example.com"
                required autocomplete="email"
                .value=${this.email}
                @input=${(e: any) => (this.email = e.target.value)}
              />
            </div>

            <div class="field">
              <label class="tk-label" for="username">Username</label>
              <input
                id="username" class="tk-input" type="text" placeholder="CoolName99"
                required minlength="2" maxlength="32" autocomplete="username"
                pattern="[a-zA-Z0-9_\\-\\.]+"
                title="Letters, numbers, underscores, hyphens and dots only"
                .value=${this.username}
                @input=${(e: any) => (this.username = e.target.value)}
              />
              <div class="tk-hint">Your public display name. 2–32 characters, letters, numbers, _ - . only</div>
            </div>

            <div class="field">
              <label class="tk-label" for="pw">Password</label>
              <input
                id="pw" class="tk-input" type="password"
                required autocomplete="new-password"
                .value=${this.password}
                @input=${(e: any) => (this.password = e.target.value)}
              />
              <div class="tk-hint">At least 8 characters</div>
            </div>

            <div class="field">
              <label class="tk-label" for="pw2">Confirm password</label>
              <input
                id="pw2" class="tk-input" type="password"
                required autocomplete="new-password"
                .value=${this.confirmPassword}
                @input=${(e: any) => (this.confirmPassword = e.target.value)}
              />
            </div>

            <button class="tk-btn primary full" type="submit" ?disabled=${this.loading}>
              ${this.loading ? 'Creating account…' : 'Create account'}
            </button>
          </form>

          <div class="foot">
            Already have an account? <a href="/login">Sign in</a>
          </div>
        </div>
      </main>
    `;
  }
}
